import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortletModule } from '@gspwidget/portlet';
import { ShellTabComponent } from './shell-tab.component';

@NgModule({
  declarations: [
    ShellTabComponent,
  ],
  entryComponents: [
    // ShellTabComponent,
  ],
  imports: [
    CommonModule,
    PortletModule,
  ],
  exports: [
    ShellTabComponent,
  ],
  providers: [
  ]
})
export class ShellTabModule { }
